/* FN · Site helpers: recipe filters, copy link, footer columns. */
(function () {
  'use strict';
  if (window.__fnSite) return;
  window.__fnSite = true;

  /* Recipe filter chips */
  function initFilters(scope) {
    (scope || document).querySelectorAll('[data-fns-filter-root]').forEach(function (root) {
      if (root.__fns) return;
      root.__fns = true;
      var chips = root.querySelectorAll('[data-fns-filter]');
      var items = root.querySelectorAll('[data-fns-item]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var key = chip.getAttribute('data-fns-filter');
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          items.forEach(function (it) {
            var on = !key || it.getAttribute('data-key') === key;
            it.hidden = !on;
            it.classList.toggle('fns-post--flat', !!key);
          });
        });
      });
    });
  }

  /* Copy link */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fns-copy]');
    if (!btn) return;
    var url = btn.getAttribute('data-fns-copy');
    var label = btn.querySelector('span');
    var done = function () {
      if (!label) return;
      var old = label.textContent;
      label.textContent = btn.getAttribute('data-done') || 'Copied';
      setTimeout(function () { label.textContent = old; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
    else done();
  });

  /* Footer columns: open on desktop, collapsible on phones */
  function initFooter() {
    var mq = window.matchMedia('(max-width: 760px)');
    var cols = document.querySelectorAll('.fnf__col');
    function sync() { cols.forEach(function (d) { d.open = !mq.matches; }); }
    cols.forEach(function (d) {
      d.querySelector('summary').addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); });
    });
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
  }

  function init() { initFilters(document); initFooter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { initFilters(e.target); });
})();
